<template>
  <div class="activation-container">
    <loader />
  </div>
</template>

<script>
import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

import Loader from '@/components/otherElements/Loader';

export default {
  name: 'ActivationSelfEmployed',
  components: {
    Loader,
  },
  created() {
    HTTPService.selfEmployedActivation(this.$route.params.id)
      .then(() => {
        this.$alert({
          type: 'success',
          text: this.$t('common.success'),
        });
      })
      .catch(error => {
        logrocket.logger(error);

        this.$alert({
          type: 'warning',
          text: this.$t('not.success'),
        });
      })
      .finally(() => {
        this.$router.push({ name: 'cabinet' });
      });
  },
};
</script>

<style lang="sass" scoped>
  .activation-container
    width: 100%
    height: 100vh
    position: absolute
    left: 0
    right: 0
    top: 0
    bottom: 0
</style>
